import React from 'react'
import Script from 'react-load-script'

import {useLocale} from '@helios/shared/providers/locale'

export const WidgetTrustpilot = () => {
    const locale = useLocale()
    const ref = React.useRef(null)

    React.useEffect(() => {
        // If window.Trustpilot is available it means that we need to load the TrustBox from our ref.
        // If it's not, it means the script isn't loaded just yet.
        // When it is, it will automatically load the TrustBox.
        if (window.Trustpilot) {
            window.Trustpilot.loadFromElement(ref.current, true)
        }
    }, [])

    return (
        <>
            <Script
                url="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
                attributes={{async: true}}
                onLoad={() => {}}
                onError={() => console.error('Problem loading Trustpilot widget')}
            />
            {/** for the prop data-style-width we pass 103% because the Trustpilot logo
             * was not fitting on German with value 100%,
             * same on Finnish (both languages with long words) */}
            <div
                data-locale={locale.code}
                className="trustpilot-widget"
                data-template-id="5419b732fbfb950b10de65e5"
                data-businessunit-id="5884bf2d0000ff00059b41c2"
                data-style-height="24px"
                data-style-width="103%"
                data-theme="light"
                ref={ref}
            />
        </>
    )
}
